module.exports = __webpack_public_path__ + "img/41_69_015_430.f4518b40.jpg";